import {makeStyles} from "@material-ui/core";

export default makeStyles(theme => ({
  text: {
    textAlign: 'center',
    paddingBottom: theme.spacing(3)
  },
  margin: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(3)
  },
  container: {
    padding: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  input: {
    width: '100%',
    margin: theme.spacing(1)
  },
  box: {
    padding: theme.spacing(1),
    marginLeft: theme.spacing(-1),
  },
  content: {
    paddingRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.secondary[theme.palette.type]
  },
  picker: {
    width: '100%',
    margin: theme.spacing(1),
    // marginTop: theme.spacing(3),
    // marginBottom: theme.spacing(2)
  },
  title: {
    padding: theme.spacing(1)
  },
  error: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  spinner: {
    color: 'white'
  }
}));
